export default function () {
  return {
    availableMethods: {},
    loading: true,
  }
}
